export const SERVICE_CODE = 'PRODUCTION_CATEGORIES' + '_SERVICE';
